module.exports = __webpack_public_path__ + "img/about_inner5-1.38465129.png";